import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useNavigateToCancelConfirm = () => {
    const navigation = useMainStackNavigation();
    const navigateToCancelConfirm = useCallback(() => {
        navigation.navigate('ManagePremiumSubscriptionCancelConfirm');
    }, []);
    return navigateToCancelConfirm;
};
export default useNavigateToCancelConfirm;
